import React from 'react';
import {formatTeamName} from "@/utils/formatters.js";

const TeamDisplay = ({
                         team,
                         onClick,
                         w = "w-12",
                         h = "h-12",
                         flagW = "w-14",
                         flagH = "h-10",
                         textColor = "text-gray-800",
                         textSize = "text-xs"
                     }) => {

    if (!team) return <div className="w-1/3"></div>;

    const isFlag = team.code || team.logoUrl?.startsWith('https://flagcdn.com/');

    const imgSrc = team.code
        ? `https://flagcdn.com/w160/${team.code.toLowerCase()}.png`
        : team.logoUrl;

    return (
        <div
            onClick={onClick}
            className={`flex flex-col items-center w-1/3 text-center ${onClick ? 'cursor-pointer hover:scale-105 active:scale-95 transition-transform duration-200' : ''}`}
        >
            <div
                className={`relative mb-2 ${isFlag ? `${flagW} ${flagH} overflow-hidden rounded-md flag-box shadow-sm` : `${w} ${h}`}`}>
                <img
                    src={imgSrc}
                    className={isFlag
                        ? "w-full h-full object-fill"
                        : "w-full h-full object-contain drop-shadow-sm"
                    }
                    alt={team.name}
                    onError={(e) => e.target.src = 'https://via.placeholder.com/50?text=?'}
                />
            </div>

            <span className={`${textColor} ${textSize} font-bold leading-tight uppercase line-clamp-2`}>
                {formatTeamName(team.shortName || team.name || team.code)}
            </span>
        </div>
    );
};

export default TeamDisplay;